import axios from 'axios'
import { baseURL } from '../../utils/baseURL'

// , token: string
export const upsertPostUser = (dataReq: any, env: string) => {
	axios.put(baseURL(env) + 'postUser', dataReq, {
		headers: {
			/*Authorization: 'Bearer ' + token,*/
		},
	})
}
